import { useMutation, useQueryCache } from "react-query";
import { postInspectionItemFail } from "../../api/inspections/postInspectionItemFail";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";

export default function useInspectionItemFailMutation() {
  const queryCache = useQueryCache();
  const headers = useNetworkHeaders();

  const [failInspectionItem, failInspectionItemState] = useMutation(postInspectionItemFail(headers), {
    onSuccess: () => {
      queryCache.invalidateQueries();
    },
  });

  return {
    failInspectionItem: (id: string | number, sectionId: string | number, itemId: string | number) => {
      failInspectionItem({ id: Number(id), sectionId: Number(sectionId), itemId: Number(itemId) });
    },
    isLoading: failInspectionItemState.isLoading,
  };
}
